<template>
  <div>









      <CRow class="mb-2 mt-0 pt-0">
          <CCol md="12" class="mt-0 pt-0" >
              <b-button size="sm" v-if="issueMoreDetailShow" @click="issueMoreDetailShow = false">نمایش کمتر</b-button>
              <b-button size="sm"  v-if="!issueMoreDetailShow" @click="issueMoreDetailShow = true">نمایش بیشتر</b-button>
          </CCol>
      </CRow>



      <CRow>
          <CCol md="9">



              <CCard class="center-div">




                  <b-row class="mt-2">




                              <b-col md="12" class="">

                                  <b-col md="12" class="bg-white ml-1" style="border-bottom: 4px solid #eee">




                                      <addIssue  :parent_id="addIssue.parent_id"
                                                 :reply_id="addIssue.reply_id"
                                                 :section_id="addIssue.section_id"

                                             >
                                      </addIssue>


<!--                                      :processes="processes"-->
<!--                                      :steps="steps"-->
<!--                                      :orders="orders"-->
<!--                                      :contacts="contacts"-->
<!--                                      :projects="projects"-->

                                  </b-col>
                              </b-col>






                  </b-row>

              </CCard>



              <div>




                  <b-row class="">


                      <b-col md="12">
                          <b-row class="">




                              <b-col md="12">




                                  <div id="testTable" class="table  table-hover table-bordered table-responsive table-fit">


                                      <ul style="width: 100%!important;padding: 0" >

                                          <li  v-for="(issue, issueIndex) in issues" :key="issueIndex"
                                               style="width: 100%!important;border-top: 2px solid #9e9e9e;background-color: #fafafa;border-radius: 6px;
                                       overflow-x: hidden;margin-bottom: 15px;box-shadow: 0 0 3px rgba(0,0,0,.04)">

                                              <issueList  :issue="issue" :issueMoreDetailShow="issueMoreDetailShow">
                                              </issueList>

                                          </li>

                                  <scroll-loader v-if="loadMore"  :loader-method="getMoreIssues" :loader-enable="loadMore">
                                  </scroll-loader>



                                      </ul>
                                  </div>
                              </b-col>
                          </b-row>

                      </b-col>





                  </b-row>


              </div>

          </CCol>





          <CCol md="3">

              <CCard class="p-4">

                  <div class="message-show text-right pt-3" >




                      <div
                              style="cursor: pointer" >
                          <div class="text-right margin-10 d-flex">
                              <!--                                        tagSearc
                                              var url = '/home/file/fileSearch/?input='+app.tagSearch
                              h-->

                              <div class="row text-right ">

                                  <div class="col-6 my-2">
                                      <small> از تاریخ ثبت:</small>
                                      <custom-time-picker
                                              v-model="search.created_at_from" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>

                                  <div class="col-6 my-2">
                                      <small> تا تاریخ ثبت:</small>
                                      <custom-time-picker
                                              v-model="search.created_at_to" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>



                                <div class="col-6 my-2">
                                  <small> از تاریخ شروع:</small>
                                  <custom-time-picker
                                      v-model="search.start_date_from" @change="getIssues()"
                                      type="date" :clearable="true" placeholder="" min="" max=""
                                      size="sm" input-class="form-control form-control-sm">
                                  </custom-time-picker>
                                </div>

                                <div class="col-6 my-2">
                                  <small> تا تاریخ شروع:</small>
                                  <custom-time-picker
                                      v-model="search.start_date_to" @change="getIssues()"
                                      type="date" :clearable="true" placeholder="" min="" max=""
                                      size="sm" input-class="form-control form-control-sm">
                                  </custom-time-picker>
                                </div>


                                  <div class="col-6 my-2">
                                      <small> از تاریخ انجام:</small>
                                      <custom-time-picker
                                              v-model="search.done_date_from" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>

                                  <div class="col-6 my-2">
                                      <small> تا تاریخ انجام:</small>
                                      <custom-time-picker
                                              v-model="search.done_date_to" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>


<!--                                  <div class="col-12">-->
<!--                                      <label> برچسب:</label>-->

<!--&lt;!&ndash;                                      <b-form-input&ndash;&gt;-->
<!--&lt;!&ndash;                                              v-model="tagSearch"&ndash;&gt;-->
<!--&lt;!&ndash;                                              type="text"&ndash;&gt;-->
<!--&lt;!&ndash;                                              @keyup="getIssues()"&ndash;&gt;-->
<!--&lt;!&ndash;                                              size="sm"&ndash;&gt;-->
<!--&lt;!&ndash;                                              placeholder="برچسب (تگ)"&ndash;&gt;-->
<!--&lt;!&ndash;                                      ></b-form-input>&ndash;&gt;-->

<!--                                  </div>-->


                                <div class="col-12 my-2">
                                  <small>  Parent:</small>
                                  <b-form-select  size="sm" style="direction: ltr"
                                                  @change="getIssues()"
                                                  v-model="search.parent_id"
                                                  type="text">
                                    <b-form-select-option  value="">
                                      همه
                                    </b-form-select-option>
                                    <b-form-select-option  value="0">
                                      سرشاخه
                                    </b-form-select-option>

                                  </b-form-select>
                                </div>




                                <div class="col-12 my-2">
                                      <small> موضوع:</small>
                                      <b-form-input v-model="search.title"
                                                    @keyup="getIssues()"
                                                    size="sm"
                                                    type="text"
                                                    placeholder="">
                                      </b-form-input>
                                  </div>




                                  <div class="col-12 my-2">
                                      <small>  نوع:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.type"
                                                      type="text">
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>

                                          <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                 :value="type.id"  >
                                              {{type.title}}
                                          </b-form-select-option>
                                          <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>

                                      </b-form-select>
                                  </div>



                                  <div class="col-12 my-2">
                                      <small>  وضعیت انجام:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.board_id"
                                                      type="text">
                                          <b-form-select-option  value="">همه</b-form-select-option>
                                          <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                          <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                          <b-form-select-option  value="3"  style="color: #aeb130">درحال انجام (Doing)</b-form-select-option>
                                          <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>
                                          <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                      </b-form-select>
                                  </div>

                                <div class="col-12 my-2">
                                      <small>  اولویت:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.priority"
                                                      type="text">
                                          <b-form-select-option  value="">همه</b-form-select-option>
                                          <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                          <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                          <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                      </b-form-select>
                                  </div>


                                  <div class="col-12 my-2">
                                      <small> فرایند:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      v-model="search.process_id" @change="getIssues()"
                                      >
<!--                                          getSteps($event) &&-->
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>
                                          <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                                 :value="process.id"  >
                                              {{process.title}}
                                          </b-form-select-option>

                                      </b-form-select>
                                  </div>

                                  <div class="col-12 my-2">
                                      <small> مرحله:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      v-model="search.step_id" @change="getIssues()"
                                      >
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>
                                          <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                              {{step.title}}
                                          </b-form-select-option>



                                      </b-form-select>
                                  </div>







                                  <div class="col-12 my-2">
                                      <small> مشتری:</small>
                                      <v-select @change="getIssues()"
                                              v-model="search.contact_id"
                                              :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                                      </v-select>


                                      <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                                      <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                                      <!--                            </multiselect>-->
                                  </div>

                                  <div class="col-12 my-2">
                                      <small>پروژه:</small>

                                      <v-select @change="getIssues()"
                                              v-model="search.project_id"
                                              :options="projects" label="title" :reduce="project => project.id" value="id">
                                      </v-select>

                                  </div>

                                  <div class="col-12 my-2">

                                    <b-checkbox v-model="search.close_date"> <small>نمایش آرشیو (بسته) شده ها</small>
                                    </b-checkbox>

                                  </div>





<!--                                  <div class="col-12 my-2">-->
<!--                                      <small> {{$client}}:</small>-->
<!--                                      <b-form-select  size="sm" style="direction: ltr"-->
<!--                                                      v-model="search.contact_id" @change="getIssues()"-->
<!--                                      >-->
<!--                                          <b-form-select-option  value="">-->
<!--                                              همه-->
<!--                                          </b-form-select-option>-->

<!--                                          <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"   :value="contact.id" >-->
<!--                                              {{contact.last_name}}-->
<!--                                          </b-form-select-option>-->


<!--                                      </b-form-select>-->
<!--                                  </div>-->

<!--                                  <div class="col-12 my-2">-->
<!--                                      <small> پروژه:</small>-->
<!--                                      <b-form-select  size="sm" style="direction: ltr"-->
<!--                                      >-->
<!--                                          <b-form-select-option  value="">-->
<!--                                              همه-->
<!--                                          </b-form-select-option>-->


<!--                                      </b-form-select>-->
<!--                                  </div>-->
                                  <div class="col-12 mt-3">
                                      <button @click="getIssues()" class="btn btn-success">فیلتر</button>
                                  </div>


                              </div>




                              <!--                                  <multiselect  v-model="newPost.fileLib_tags" :height="300" :options="options" :multiple="true"-->
                              <!--                                                                  :taggable="true" :close-on-select="false" :clear-on-select="false"-->
                              <!--                                                                  :custom-label="customLabel"-->
                              <!--                                                                  :preserve-search="true" :hide-selected="true" :show-labels="false"-->
                              <!--                                                                  tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"-->
                              <!--                                                                  label="title" track-by="title" :preselect-first="false"-->

                              <!--                                                                  @tag="addTag">-->
                              <!--                                                        &lt;!&ndash; <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"-->
                              <!--                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> &ndash;&gt;-->
                              <!--                                        </multiselect>-->
                          </div>
                      </div>







                  </div>

              </CCard>

<!--              <CCard class="p-4">-->


<!--                  <b-row class="ml-1">-->
<!--                      &lt;!&ndash;                              <b-col md=12 class="text-right my-2">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  <router-link :to="{path : '/social/course/intro'}">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      <div class="bg-blue p-3">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <h4 class="text-white my-2 mb-2 h5">   sayan</h4>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <small class="text-white">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                              </small>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                <p class="m-0">&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                    <b-img-lazy src="/image/avatars.png" alt="Image 3" class="float-left tree-circle">&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                    </b-img-lazy> <i class="fas fa-check-circle color-check"></i>&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                </p>&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      </div>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  </router-link>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              </b-col>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              <b-col md=12 class="text-right my-2">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  <router-link :to="{path : '/social/forum/intro'}">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      <div class="bg-blue-light p-3">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <h4 class="text-white my-2 mb-2 h5">  sayan</h4>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <small class="text-white"></small>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      </div>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  </router-link>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              </b-col>&ndash;&gt;-->












<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">پیگیری ها (Tickets)</div>-->
<!--                          <small style="color: #b0bec5">33 از 44 انجام شده (60%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="warning"-->
<!--                                  :value="60"-->
<!--                          />-->
<!--                      </CCol>-->
<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">سرنخ/فرصت های {{$sale}} </div>-->
<!--                          <small style="color: #b0bec5">33 از 84 پیگیری شده (80%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="danger"-->
<!--                                  :value="80"-->
<!--                          />-->
<!--                      </CCol>-->


<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-none">-->
<!--                          <div class="text-muted">ایراد ها (Bugs) </div>-->
<!--                          <small style="color: #b0bec5">73 از 84 رفع شده (80%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="danger"-->
<!--                                  :value="80"-->
<!--                          />-->
<!--                      </CCol>-->


<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-md-down-none">-->
<!--                          <div class="text-muted">فعالیت ها (Tasks) </div>-->
<!--                          <small style="color: #b0bec5">11 از 22 انجام شده (50%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  :value="40"-->
<!--                          />-->
<!--                      </CCol>-->
<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">ملاقات ها / جلسات</div>-->
<!--                          <small style="color: #b0bec5">22 از 44 برگزار شده (50%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="success"-->
<!--                                  :value="40"-->
<!--                          />-->
<!--                      </CCol>-->



<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-md-down-none">-->
<!--                          <div class="text-muted">Epics / User Stories</div>-->
<!--                          <small style="color: #b0bec5">6 از 21 تمام شده (34%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="info"-->
<!--                                  :value="20"-->
<!--                          />-->
<!--                      </CCol>-->




<!--                  </b-row>-->
<!--              </CCard>-->
          </CCol>


<!--          <BootstrapTable :columns="columns" :data="data" :options="tableOptions"></BootstrapTable>-->



      </CRow>










  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'

import BootstrapTable from 'bootstrap-table'

import { CChartLineSimple, CChartBarSimple } from './charts/index'

import Multiselect from 'vue-multiselect'

import addIssue from './issue/add'
import issueList from "./issue/list";

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
      CChartLineSimple,
      CChartBarSimple,

      Multiselect,

      addIssue,
      issueList,

      BootstrapTable




  },
  data () {
    return {
      selected: 'Month',
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'cif-us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'cif-br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'cib-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'cif-in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'cib-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'cif-fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'cib-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'cif-es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'cif-pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'cib-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: [
        { key: 'avatar', label: '', _classes: 'text-center' },
        { key: 'user' },
        { key: 'country', _classes: 'text-center' },
        { key: 'usage' },
        { key: 'payment', label: 'Payment method', _classes: 'text-center' },
        { key: 'activity' },
      ],





        auth: {
            headers: {
                Authorization: 'bearer ' + localStorage.getItem('token')
            }
        },

        role: localStorage.getItem('role'),
        authUser:
            {
                id:localStorage.getItem('id'),
            },



        loadMore: true,
        page: 1,
        pageSize: 10,
        voice: '',

        courseCategories:[],
        fileCategories:[],
        forumCategories:[],
        forums:[],


        issues:[],
        issueText: 0,


        rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

        showVoiceRecorder: false,
        showFileUploader: false,
        showImageUploader: false,
        showVideoUploader: false,

        src: null,
        srcPlay: null,

        issueAsCourse: false,
        issueAsForum: false,

        courseDisabled: false,
        forumDisabled: false,

        newComment:'',
        newReply:'',

        options:[],

        selectedTags: [],
        tags: [],
        isLoading: false,




        typeOptions: [
            { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
            { value: 'bug', text: 'ایراد (Bug)' },
            { value: 'task', text: 'فعالیت (Task)' },
            { value: 'story', text: 'لیست (Story)' },
            { value: 'epic', text: 'نسخه/فیچر (Epic)' },
            { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
            { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

        ],



        warningModal: false,


        search: {

                title: '',
                description: '',
                type: '',
                project_id: '',
                section_id: '',
                process_id: '',
                step_id: '',
                board_id: '',

                created_at_from: '',
                created_at_to: '',
                due_date: '',
                start_date: '',
                done_date_from: '',
                done_date_to: '',
                close_date: '',

                priority: '',
                contact_id: '',
                order_id: '',
                person_id: '',
                created_by: '',
                updated_by: '',

                parent_id: 0,
        },


        contact_id: '',




        addIssue: {
            parent_id: null,
            reply_id: null,
            sprint_id: null,
            board_id: null,
            process_id: null,
            section_id: null,
            step_id: null
        },

        processes: [],
        steps: [],
        orders: [],
        contacts: [],
        projects: [],


        types: [],









        columns: [
            {
                title: 'Item ID',
                field: 'id'
            },
            {
                field: 'name',
                title: 'Item Name'
            }, {
                field: 'price',
                title: 'Item Price'
            }
        ],
        data: [
            {
                id: 1,
                name: 'Item 1',
                price: '$1'
            }
        ],
        tableOptions: {
            search: true,
            showColumns: true
        },


        issueMoreDetailShow:true,




    }
  },


    watch: {


        search: {
            deep: true,
            handler() {

                this.getSteps(this.search.process_id)

            }
        }



        },



    beforeRouteUpdate(to, from, next) {
        // this.getProcesses()
        // this.getSteps()
        // this.getProjects()
        // this.getOrders()
        // this.getContacts()
        // this.getUsers()
    },


    mounted() {


        //move to search component
        this.getTypes()
        this.getProcesses()
        this.getSteps()
        this.getProjects()
        // this.getOrders()
        this.getContacts()
        // this.getUsers()




    },



    methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },








        getIssues(){
            var app = this;

            axios.get('/api/intro/index' +
                '?title='+app.search.title+
                '&description='+app.search.description+
                '&type='+app.search.type+
                '&project_id='+app.search.project_id+
                '&section_id='+app.search.section_id+

                '&process_id='+app.search.process_id+
                '&step_id='+app.search.step_id+
                '&board_id='+app.search.board_id+

                '&created_at_from='+app.search.created_at_from+
                '&created_at='+app.search.created_at_to+
                '&created_at_to='+app.search.due_date+
                '&start_date='+app.search.start_date+
                '&done_date_from='+app.search.done_date_from+
                '&done_date_to='+app.search.done_date_to+
                '&close_date='+app.search.close_date+

                '&priority='+app.search.priority+
                '&contact_id='+app.search.contact_id+
                '&order_id='+app.search.order_id+
                '&person_id='+app.search.person_id+
                '&created_by='+app.search.created_by+
                '&updated_by='+app.search.updated_by+
                '&parent_id='+app.search.parent_id
                , app.auth)
                .then(function (response) {
                    app.issues = response.data.data
                    // console.log(response.data);
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getMoreIssues(){
            var app = this;



            if(app.loadMore == true){

                axios.get('/api/intro/index' +
                    '?title='+app.search.title+
                    '&description='+app.search.description+
                    '&type='+app.search.type+
                    '&project_id='+app.search.project_id+
                    '&section_id='+app.search.section_id+

                    '&process_id='+app.search.process_id+
                    '&step_id='+app.search.step_id+
                    '&board_id='+app.search.board_id+

                    '&created_at_from='+app.search.created_at_from+
                    '&created_at='+app.search.created_at_to+
                    '&created_at_to='+app.search.due_date+
                    '&start_date='+app.search.start_date+
                    '&done_date_from='+app.search.done_date_from+
                    '&done_date_to='+app.search.done_date_to+
                    '&close_date='+app.search.close_date+

                    '&priority='+app.search.priority+
                    '&contact_id='+app.search.contact_id+
                    '&order_id='+app.search.order_id+
                    '&person_id='+app.search.person_id+
                    '&created_by='+app.search.created_by+
                    '&updated_by='+app.search.updated_by+
                    '&parent_id='+app.search.parent_id+
              '&page='+app.page , app.auth)
                    .then(res => {
                        // app.issues.concat(res.data.data)
                        res.data.data.forEach(
                            (val)=>{ app.issues.push(val)});

                        app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                        // Stop scroll-loader
                        res.data.data.length < app.pageSize && (app.loadMore = false)
                    })
                    .catch(error => {
                        console.log(error);
                    })

            }


        },


        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },



        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        headerStyles(issueType){
            if (issueType.type == 1)
                return '2px solid #880e4e'
            else if (issueType.type == 2)
                return '2px solid #f50057'
            else if (issueType.type == 3)
                return '2px solid #8e24aa'
            else if (issueType.type == 4)
                return '2px solid #263238'
            else if (issueType.type == 5)
                return '2px solid #dd2c00'
            else if (issueType.type == 6)
                return '2px solid #00c853'
            else if (issueType.type == 7)
                return '2px solid #0097a7'
            else if (issueType.type == 8)
                return '2px solid #0288d1'
            else if (issueType.type == 9)
                return '2px solid #0208ff'
            else if (issueType.type == 10)
                return '2px solid #eeb600'
            else if (issueType.type == 10)
                return '2px solid #0e8e2e'
            else if (issueType.type == 11)
                return '2px solid #888'
            else
                return '2px solid #888888'
        },



        boardColor(boardID){
            if (boardID == 1)
                return '#ee6600'
            else if (boardID == 2)
                return '#ffd600'
            else if (boardID == 3)
                return '#aeb130'
            else if (boardID == 4)
                return '#64dd17'
            else if (boardID == 5)
                return '#0097a7'
            else if (boardID == 6)
                return '#00bfa5'
            else
                return ''
        },

        typeBadgeStyles(issueType){
            if (issueType.type == 1)
                return '#880e4e'
            else if (issueType.type == 2)
                return '#f50057'
            else if (issueType.type == 3)
                return '#8e24aa'
            else if (issueType.type == 4)
                return '#263238'
            else if (issueType.type == 5)
                return '#dd2c00'
            else if (issueType.type == 6)
                return '#00c853'
            else if (issueType.type == 7)
                return '#0097a7'
            else if (issueType.type == 8)
                return '#0288d1'
            else if (issueType.type == 9)
                return '#0208ff'
            else if (issueType.type == 10)
                return '#eeb600'
            else if (issueType.type == 10)
                return '#0e8e2e'
            else if (issueType.type == 11)
                return '#888'
            else
                return '#888888'
        },







        issueTypeText(issueType) {
            if (issueType.type == 1)
                return 'سرنخ (Lead)'
            else if (issueType.type == 2)
                return 'فرصت (Opportunity)'
            else if (issueType.type == 3)
                return 'ملاقات/جلسه/رویداد'
            else if (issueType.type == 4)
                return 'پیگیری (Ticket)'
            else if (issueType.type == 5)
                return 'ایراد (Bug)'
            else if (issueType.type == 6)
                return 'فعالیت (Task)'
            else if (issueType.type == 7)
                return 'لیست/شرح (Story)'
            else if (issueType.type == 8)
                return 'مجموعه/امکانات (Epic)'
            else if (issueType.type == 9)
                return 'پیام/تلفن (Message)'
            else if (issueType.type == 10)
                return 'گزارش/خبر (Report)'
            else if (issueType.type == 11)
                return 'سایر'
            else
                return 'سایر'
        },




        customLabel(option) {
            //   console.log(option.title)

            //   this.item.tags.push(option)
            return `${option.title}`

        },


        ajaxFindTag(query){

        },


        limitText (count) {
            return `and ${count} other tags`
        },
        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },
        clearAll () {
            this.selectedTags = []
        },



        getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                    app.processes = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                    app.steps = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.orders = response.data.data;
                    // console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false
                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },
        getContacts(){

            axios.get('/api/contactslist', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.contacts = response.data;
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false

                    this.makeContactOptions()

                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },
        //
        // makeContactOptions(){
        //     var app = this;
        //
        //     for (const key in app.contacts) {
        //         if (app.contacts.hasOwnProperty(key)) {
        //             const element = app.contacts[key];
        //
        //             app.contactOptions.push({
        //                 value: element.id,
        //                 text: element.first_name+' '+element.last_name
        //             })
        //             // this.details[0].
        //         }
        //     }
        //     // console.log(app.contacts)
        //     // console.log(app.contactOptions)
        //
        //
        // },

        getProjects() {
            axios
                .get('/api/projectList', this.auth)
                .then(response => {

                    this.projects = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
        },



        getTypes(){
            var app = this;
            axios.get('/api/issueTypeList', app.auth)
                .then(function (response) {
                    app.types = response.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },







    }
}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
